import _SkeletonTitle from "./SkeletonTitle.mjs";
import { withInstall } from "../utils/index.mjs";
const SkeletonTitle = withInstall(_SkeletonTitle);
var stdin_default = SkeletonTitle;
import { skeletonTitleProps } from "./SkeletonTitle.mjs";
export {
  SkeletonTitle,
  stdin_default as default,
  skeletonTitleProps
};
